function EidQuota() {
    "use strict";
    this.__type = 'EidQuota:www.veritracks.com';
    this.Id = -1;
    this.OrganizationId = -1
    this.EidTypeId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EidQuota;
}